import React from "react";
import { Overlay, Menu } from "components/generic/layout";

export default ({
  onSignOut,
  pushToDashboard,
  pushToProfile,
  pushToInvitation
}) => (
  <Menu
    MenuLinks={
      <React.Fragment>
        <Overlay.MenuLink onClick={() => pushToDashboard()}>
          My calls
        </Overlay.MenuLink>
        <Overlay.MenuLink onClick={() => pushToProfile()}>
          My profile
        </Overlay.MenuLink>
        <Overlay.MenuLink onClick={() => pushToInvitation()}>
          Refer a friend
        </Overlay.MenuLink>
        <Overlay.MenuLink onClick={() => onSignOut()}>
          Sign out
        </Overlay.MenuLink>
      </React.Fragment>
    }
  />
);



// WEBPACK FOOTER //
// ./src/components/common/candidate/Overlay/Menu/View.js